import FormaterColorWeek from '../Components/Formaters/FormaterColorWeek';
import FormaterColorFact from '../Components/Formaters/FormaterColorFact';
import FormaterDate from '../Components/Formaters/FormaterDate';
import FormaterString from '../Components/Formaters/FormaterString';
import FormaterID from '../Components/Formaters/FormaterID';
import * as api from '../api/apiFunc';

const lday = 50;
function CustomHeader(item) {
    return api.CustomFormatter(item.column.name,'white','#343433',0.7)
}

export const columnsMainData = [
    {
        key: 'ID', name: 'ID', frozen: false, resizable: true, width: 100, _type: 0, headerRenderer: CustomHeader,
        formatter(props) { const value = props.row.ID; return <FormaterID value={value} Align={'left'} Src='static/img/add_row.png' Width='30%' Height='40%' Color='black' FontSize = '90%'  />; }
    },
    {
        key: 'DIRECTIONCODE', name: 'Код направления', resizable: true, frozen: false, editable: true, width: 150, _type: 0,
        headerRenderer: CustomHeader,
        formatter(props) { const value = props.row.DIRECTIONCODE; return <FormaterString value={value} Align={'left'} Color='black' FontSize = '90%'  />; }
    },
    {
        key: 'DIRECTIONNAME', name: 'Наименование направления', resizable: true, editable: true, width: 400, _type: 0, headerRenderer: CustomHeader,
        formatter(props) { const value = props.row.DIRECTIONNAME; return <FormaterString value={value} Align={'left'} Color='black' FontSize = '90%'  />; }
    },
    {
        key: 'DIRECTIONNAMEEN', name: 'Наименование направления(англ.)', resizable: true, editable: true, width: 400, _type: 0, headerRenderer: CustomHeader,
        formatter(props) { const value = props.row.DIRECTIONNAMEEN; return <FormaterString value={value} Align={'left'} Color='black' FontSize = '90%'  />; }
    },
]

export const columnsFilter = [
    { key: 'DIRECTIONCODE', name: 'Код направления', _typecolumn :  null, _picklist : null, _typedata : 1, _filterval: "", },
    { key: 'DIRECTIONNAME', name: 'Наименование направления', _typecolumn :  null, _picklist : null, _typedata : 1, _filterval: "", },
    { key: 'DIRECTIONNAMEEN', name: 'Наименование направления (англ.)', _typecolumn :  null, _picklist : null, _typedata : 4, _filterval: "", },
  ]

  
export const columnsMainDataOLD = [
    { key: 'vidp', name: 'Т',frozen : true,resizable: false,width:30,maxWidth:30,_type:0,headerRenderer: CustomHeader },
    {
        key: 'taskp', name: 'Задача', resizable: true, frozen: true, editable: false, width: 570, _type: 0,
        headerRenderer: CustomHeader,
        summaryFormatter() { return <strong>Итого</strong>; },
        formatter(props) { const value = props.row.taskp; return <FormaterString value={value} Align={'left'} Color='black' FontSize = '90%'  />; }
    },
    {
        key: 'datan', name: 'Начало', resizable: true, editable: false, width: 120, _type: 0, headerRenderer: CustomHeader,
        formatter(props) { const val = props.row.datan;
            return <FormaterDate value={val} Align={'center'} Color='black' FontSize = '100%' />;
          }
    },
    {
        key: 'datak', name: 'Конец', resizable: true, editable: false, width: 120, _type: 0, headerRenderer: CustomHeader,
        formatter(props) { const val = props.row.datak;
            return <FormaterDate value={val} Align={'center'} Color='black' FontSize = '100%' />;
          }
    },
    { key: 'planh', name: 'План,ч.',resizable: true,editable: false,width:60,maxWidth:60,_type:0,headerRenderer: CustomHeader ,
    summaryFormatter({ row }) { return <FormaterColorFact FKey={'facth'} Value={row.planh} datan={row.datan} summary={1} Align={'center'} Color='black' FontSize='90%' /> },
    formatter(props) { const value = props.row.planh; return <FormaterColorFact FKey={'facth'} Value={value} plan = {null} datan={props.row.datan} summary={0} Align={'center'} Color='black' FontSize='90%' />; }
    },
    { key: 'facth', name: 'Факт,ч.', resizable: true, editable: false, width: 60,maxWidth:60, _type: 1, headerRenderer: CustomHeader,
    summaryFormatter({ row }) { return <FormaterColorFact FKey={'facth'} Value={row.facth} datan={row.datan} summary={1} Align={'center'} Color='black' FontSize='90%' /> },
    formatter(props) { const value = props.row.facth; return <FormaterColorFact FKey={'facth'} Value={value} plan = {props.row.plan} datan={props.row.datan} summary={0} Align={'center'} Color='black' FontSize='90%' />; }
    },
    { key: 'done', name: 'Вып.',resizable: true,editable: false,width:40,maxWidth:40,_type:0,headerRenderer: CustomHeader,
    summaryFormatter({ row }) { return <FormaterColorFact FKey={'done'} Value={row.done} datan={row.datan} summary={1} Align={'center'} Color='black' FontSize='90%' /> },
    formatter(props) { const value = props.row.done; return <FormaterColorFact FKey={'done'} Value={value} plan = {null} datan={props.row.datan} summary={0} Align={'center'} Color='black' FontSize='90%' />; }
    },
    { key: 'd01', name: '1', resizable: false, editable: true, width: lday,maxWidth:lday, _type: 1,headerRenderer: CustomHeader,
        summaryFormatter({ row }) { return <FormaterColorWeek FKey={'d01'} Value={row.d01} datan={row.datan} summary={1} Align={'center'} Color='black' FontSize='90%' /> },
        formatter(props) { const value = props.row.d01; return <FormaterColorWeek FKey={'d01'} Value={value} category={props.row.category_id} datan={props.row.datan} summary={0} Align={'center'} Color='black' FontSize='90%' />; }
    },
]

export const columnsAppTasks = [
    { key: 'application_id', name: 'App_id',resizable: true,editable: false,width:120 },
    { key: 'Name', name: 'Наименование проекта',resizable: true,editable: false,width:600 },
    { key: 'Mnem', name: 'Мнемоника',resizable: true,editable: true},
  /*  { key: 'Author', name: 'Автор',resizable: true,editable: true,width:240 },
    { key: 'Version', name: 'Версия',resizable: true,editable: true,width:70 },
    { key: 'Date_creation', name: 'Дата создания',resizable: true,editable: true,width:140 },
    { key: 'Date_update', name: 'Дата последнего обновления',resizable: true,editable: true,width:140 },*/
]

export const columnsUsersAccess = [
    { key: 'Group_id', name: 'Ключ',resizable: true,width:140 },
    { key: 'Sam_name', name: 'Название в системе AD',resizable: true,editable: false,width:250 },
    { key: 'Group_dn', name: 'Идентификатор в системе AD',resizable: true,editable: false,width:220 },
    { key: 'It_group_id', name: 'Группа ИТ',resizable: true,editable: false,width:220 },
    { key: 'Group_Note', name: 'Описание в группе',resizable: true,editable: false,width:220 },
]

export const columnsElementsList = [
    { key: 'application_id', name: 'Ключ',resizable: true,width:140 },
    { key: 'Tree_name', name: 'Название элемента меню',resizable: true,width:250 },
    { key: 'Parent_tree_name', name: 'Название родительского элемента меню',resizable: true },
    { key: 'Name', name: 'Доступ',resizable: true },
]

